import React, { useState } from 'react';
import { PlayerStats, PairingStats, OverallStats } from '../components/Statistics';
import { ChartBarIcon, UserIcon, UserGroupIcon } from '@heroicons/react/24/outline';

const StatisticsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'overall' | 'players' | 'pairings'>('overall');

  const tabs = [
    {
      id: 'overall' as const,
      name: '总体统计',
      icon: ChartBarIcon,
      description: '系统整体数据和公平性分析'
    },
    {
      id: 'players' as const,
      name: '个人统计',
      icon: UserIcon,
      description: '每个玩家的详细表现数据'
    },
    {
      id: 'pairings' as const,
      name: '配对统计',
      icon: UserGroupIcon,
      description: '搭档组合的比赛表现'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h1 className="text-2xl font-bold text-gray-900">数据统计</h1>
        <p className="text-gray-600 mt-1">全面的数据分析和统计报告</p>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white rounded-lg shadow-sm">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8 px-6">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;
              
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm ${
                    isActive
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Icon
                    className={`-ml-0.5 mr-2 h-5 w-5 ${
                      isActive ? 'text-blue-500' : 'text-gray-400 group-hover:text-gray-500'
                    }`}
                  />
                  <div className="text-left">
                    <div>{tab.name}</div>
                    <div className="text-xs text-gray-500 hidden sm:block">
                      {tab.description}
                    </div>
                  </div>
                </button>
              );
            })}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="p-6">
          {activeTab === 'overall' && <OverallStats />}
          {activeTab === 'players' && <PlayerStats />}
          {activeTab === 'pairings' && <PairingStats />}
        </div>
      </div>
    </div>
  );
};

export default StatisticsPage;